The identifier for the uploaded `CandidateProfile` to be updated.
